import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface StoredSelectedParticipant {
  id: string;
}

interface CohortState {
  selectedParticipantId: string | null;
}

const initialState: CohortState = {
  selectedParticipantId: null,
};

const cohortSlice = createSlice({
  name: "cohort",
  initialState,
  reducers: {
    setSelectedParticipantId(
      state,
      action: PayloadAction<StoredSelectedParticipant>,
    ) {
      const selectedParticipantId = action.payload.id;

      state.selectedParticipantId = selectedParticipantId;
    },
  },
});

export const { setSelectedParticipantId } = cohortSlice.actions;

export const cohortSliceReducer = cohortSlice.reducer;
